/* unplugin-vue-components disabled */import { render } from "./Kyc.vue?vue&type=template&id=64541cb5&scoped=true"
import script from "./Kyc.vue?vue&type=script&lang=js"
export * from "./Kyc.vue?vue&type=script&lang=js"

import "./Kyc.vue?vue&type=style&index=0&id=64541cb5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64541cb5"]])

export default __exports__